import React, { ComponentProps } from "react";

export default function NoLocationPin(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_2900_1027550)">
        <path
          d="M32.4716 16.7368C32.4716 26.2265 18.2358 40.0001 18.2358 40.0001C18.2358 40.0001 4 26.2272 4 16.7368C4 8.87441 10.3741 2.50098 18.2358 2.50098C26.0974 2.50098 32.4716 8.87434 32.4716 16.7368Z"
          fill="#977FF5"
        />
        <path
          d="M32.4721 16.7368C32.4721 26.2265 18.2363 40.0001 18.2363 40.0001V2.50098C26.098 2.50098 32.4721 8.87434 32.4721 16.7368Z"
          fill="#6C53E8"
        />
        <path
          d="M27.3299 16.3398C27.3299 21.3617 23.2582 25.4327 18.2362 25.4327C13.2143 25.4327 9.14258 21.3617 9.14258 16.3398C9.14258 11.3171 13.2143 7.24609 18.2362 7.24609C23.2582 7.24609 27.3299 11.3171 27.3299 16.3398Z"
          fill="#F7F7FF"
        />
        <path
          d="M27.33 16.3398C27.33 21.3617 23.2583 25.4327 18.2363 25.4327V7.24609C23.2583 7.24609 27.33 11.3171 27.33 16.3398Z"
          fill="#EAE4FB"
        />
        <path
          d="M34.4294 14.949C37.8484 11.53 37.8484 5.98664 34.4294 2.56763C31.0104 -0.851381 25.4671 -0.85138 22.0481 2.56763C18.6291 5.98664 18.6291 11.53 22.0481 14.949C25.4671 18.368 31.0104 18.368 34.4294 14.949Z"
          fill="#FF6B36"
        />
        <path
          d="M36.9984 8.75625C36.9984 13.5922 33.0781 17.5125 28.2422 17.5125V0C33.0781 0 36.9984 3.92031 36.9984 8.75625Z"
          fill="#F22F0F"
        />
        <path
          d="M29.9008 8.75615L32.3961 11.2522L30.7391 12.9093L28.2437 10.4147L28.243 10.414L25.7469 12.9101L24.0898 11.253L26.5859 8.75615L24.0898 6.26006L25.7469 4.60303L28.243 7.09912L28.2437 7.09834L30.7398 4.60303L32.3969 6.26006L29.9008 8.75615Z"
          fill="#F7F7FF"
        />
        <path
          d="M29.9012 8.75615L32.3965 11.2522L30.7395 12.9093L28.2441 10.4147V7.09834L30.7402 4.60303L32.3973 6.26006L29.9012 8.75615Z"
          fill="#EAE4FB"
        />
      </g>
      <defs>
        <clipPath id="clip0_2900_1027550">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
